/**
 * The model with nothing in it yet.
 *
 * It was a 30rem tall empty card with a bold sentence and a button floating in the
 * middle of it: about a thousand pixels of white to say one thing and offer one action,
 * on the one screen where a person has arrived to do exactly that thing. Height was
 * hard-coded, so it was that tall whatever the window.
 *
 * Now the same two elements at the size they deserve, and the button opens the datasets
 * dialog rather than navigating to `/import_data`. That is the same entry point the
 * loaded card offers, so importing the first dataset and changing the fifth are the same
 * act in the same place, which they are.
 */
import React, { useState } from 'react';
import { Button, Card } from 'react-bootstrap';

import { DatasetModal } from './DatasetModal';
import './noDatasetCard.css';

export function NoDatasetCard({ modelType }: { modelType: string }) {
  const [showModal, setShowModal] = useState(false);

  // Every type opens the dialog. Fit's asks for the source and then hosts the
  // integrations form or hands over to the route for CSV and Redshift; an
  // engagement model's hosts that model's own form straight away.

  return (
    <>
      <Card border="light" className="nodata">
        <Card.Body className="nodata-body">
          <span className="nodata-mark" aria-hidden>
            <i className="fas fa-table" />
          </span>
          <div className="nodata-text">
            <p className="nodata-title">Start here: this model has no data</p>
            <p className="nodata-sub">
              A model learns from a training dataset and is checked against a
              validation one. Nothing else on this page works until both exist.
            </p>
          </div>
          <Button onClick={() => setShowModal(true)}>Create datasets</Button>
        </Card.Body>
      </Card>
      <DatasetModal
        show={showModal}
        onHide={() => setShowModal(false)}
        hasDatasets={false}
        modelType={modelType}
      />
    </>
  );
}

export default NoDatasetCard;
